/**
 * ME Womo Banner
 * 自动轮播 + 进度条 + 左右切换 + 主题编辑器兼容
 */

(function () {
  'use strict';

  var isDesignMode = !!(window.Shopify && window.Shopify.designMode);

  function hasSlideMedia(slide) {
    return !!slide.querySelector(
      '.mt-womo-banner__image img, .mt-womo-banner__image video, .mt-womo-banner__image-desktop, .mt-womo-banner__image-mobile, .mt-womo-banner__video-desktop, .mt-womo-banner__video-mobile'
    );
  }

  function revealScrollEnterContent(section) {
    var inner = section.querySelector('[data-scroll-enter]');
    if (!inner) return;
    inner.querySelectorAll('.enter-title, .enter-subtitle, .enter-content').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function getViewportWidth(section) {
    var viewport = section.querySelector('[data-viewport]');
    return viewport ? viewport.getBoundingClientRect().width : 0;
  }

  function findSlideIndexByBlockId(section, blockId) {
    if (!blockId) return -1;
    var slides = section.querySelectorAll('.mt-womo-banner__slide');
    for (var i = 0; i < slides.length; i++) {
      var editorAttr = slides[i].getAttribute('data-shopify-editor-block');
      if (editorAttr && editorAttr.indexOf(blockId) !== -1) return i;
      if (slides[i].dataset.blockId === blockId) return i;
    }
    return -1;
  }

  function syncSlideWidths(section, track, slides) {
    var width = getViewportWidth(section);
    if (!width || !slides.length) return width;

    slides.forEach(function (slide) {
      slide.style.flex = '0 0 ' + width + 'px';
      slide.style.width = width + 'px';
      slide.style.minWidth = width + 'px';
    });
    track.style.width = width * slides.length + 'px';
    return width;
  }

  function syncSlideVideos(slides, activeIndex) {
    slides.forEach(function (slide, i) {
      slide.querySelectorAll('video').forEach(function (video) {
        if (i === activeIndex) {
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        } else {
          video.pause();
        }
      });
    });
  }

  function createBannerController(section) {
    var track = section.querySelector('[data-track]');
    var slides = track ? Array.from(track.children) : [];
    if (!track || !slides.length) return null;

    var slideCount = parseInt(section.dataset.slideCount, 10);
    var mediaSlideCount = Number.isFinite(slideCount) ? slideCount : slides.length;
    var isSingleSlide = mediaSlideCount <= 1 || slides.length <= 1;
    var progressDots = Array.from(section.querySelectorAll('[data-progress-dot]'));
    var autoplayInterval = parseInt(section.dataset.autoplayInterval, 10) || 5000;
    var autoplayEnabled = section.dataset.autoplayEnabled === 'true';
    var currentIndex = 0;
    var autoplayTimer = null;
    var progressStartTime = null;
    var progressRafId = null;
    var resizeTimer = null;

    function applyTransform(index) {
      var width = syncSlideWidths(section, track, slides);
      if (width > 0) {
        track.style.transform = 'translateX(' + -index * width + 'px)';
      } else {
        track.style.transform = 'translateX(' + -index * 100 + '%)';
      }
    }

    function setActiveSlide(index, options) {
      options = options || {};
      if (!slides.length) return;
      currentIndex = Math.max(0, Math.min(index, slides.length - 1));

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === currentIndex);
      });
      applyTransform(currentIndex);

      progressDots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
      });

      if (!isDesignMode) {
        syncSlideVideos(slides, currentIndex);
      }

      if (!options.skipProgressRestart && !isDesignMode && autoplayEnabled && !isSingleSlide) {
        restartProgress();
      }
    }

    function clearAutoplay() {
      if (autoplayTimer) {
        clearTimeout(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function stopProgress() {
      if (progressRafId) {
        cancelAnimationFrame(progressRafId);
        progressRafId = null;
      }
      progressStartTime = null;
      progressDots.forEach(function (dot) {
        var bar = dot.querySelector('[data-progress-dot-bar]');
        if (bar) bar.style.width = '0%';
      });
    }

    function startProgress() {
      var activeDot = progressDots[currentIndex];
      if (!activeDot) return;
      var progressBar = activeDot.querySelector('[data-progress-dot-bar]');
      if (!progressBar) return;

      stopProgress();
      progressStartTime = performance.now();
      progressBar.style.width = '0%';

      function loop(now) {
        if (!progressStartTime) return;
        var elapsed = now - progressStartTime;
        var ratio = Math.min(elapsed / autoplayInterval, 1);
        progressBar.style.width = (ratio * 100).toFixed(2) + '%';
        if (ratio < 1) {
          progressRafId = requestAnimationFrame(loop);
        } else {
          progressBar.style.width = '100%';
        }
      }

      progressRafId = requestAnimationFrame(loop);
    }

    function restartProgress() {
      clearAutoplay();
      if (!autoplayEnabled || isSingleSlide) {
        stopProgress();
        return;
      }
      autoplayTimer = setTimeout(function () {
        goTo(currentIndex + 1);
      }, autoplayInterval);
      startProgress();
    }

    function goTo(index) {
      if (!slides.length) return;
      setActiveSlide((index + slides.length) % slides.length);
    }

    function bindInteractions() {
      if (isDesignMode || isSingleSlide) return;

      var prevBtn = section.querySelector('[data-prev]');
      var nextBtn = section.querySelector('[data-next]');
      var leftDragZone = section.querySelector('[data-drag-left]');
      var rightDragZone = section.querySelector('[data-drag-right]');

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); });

      progressDots.forEach(function (dot, index) {
        dot.addEventListener('click', function () { goTo(index); });
      });

      setupDragZone(leftDragZone, function () { goTo(currentIndex + 1); }, function () { goTo(currentIndex - 1); });
      setupDragZone(rightDragZone, function () { goTo(currentIndex + 1); }, function () { goTo(currentIndex - 1); });
    }

    function setupDragZone(zone, onNext, onPrev) {
      if (!zone) return;
      var isDown = false;
      var startX = 0;
      var startY = 0;

      function getClientX(event) {
        if (event.touches && event.touches.length) return event.touches[0].clientX;
        if (event.changedTouches && event.changedTouches.length) return event.changedTouches[0].clientX;
        return event.clientX;
      }

      zone.addEventListener('mousedown', function (e) {
        e.preventDefault();
        isDown = true;
        startX = e.clientX;
        startY = e.clientY;
        zone.classList.add('is-dragging');
        section.classList.add('is-dragging');
      });

      window.addEventListener('mouseup', function (e) {
        if (!isDown) return;
        isDown = false;
        zone.classList.remove('is-dragging');
        section.classList.remove('is-dragging');
        var deltaX = e.clientX - startX;
        var deltaY = e.clientY - startY;
        if (Math.abs(deltaX) <= Math.abs(deltaY)) return;
        if (deltaX <= -10) onNext();
        else if (deltaX >= 10) onPrev();
      });

      zone.addEventListener('touchstart', function (e) {
        var clientX = getClientX(e);
        if (clientX == null) return;
        isDown = true;
        startX = clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });

      window.addEventListener('touchend', function (e) {
        if (!isDown) return;
        isDown = false;
        var clientX = getClientX(e);
        var clientY = e.changedTouches && e.changedTouches.length ? e.changedTouches[0].clientY : startY;
        if (clientX == null) return;
        var deltaX = clientX - startX;
        var deltaY = clientY - startY;
        if (Math.abs(deltaX) <= Math.abs(deltaY)) return;
        if (deltaX <= -10) onNext();
        else if (deltaX >= 10) onPrev();
      });
    }

    function initSlides() {
      if (isSingleSlide) {
        section.classList.add('mt-womo-banner--single');
        var mediaSlides = slides.filter(hasSlideMedia);
        var activeIndex = 0;
        if (mediaSlides.length >= 1) {
          activeIndex = Math.max(0, slides.indexOf(mediaSlides[0]));
        }
        setActiveSlide(activeIndex, { skipProgressRestart: true });
        revealScrollEnterContent(section);
        return;
      }

      section.classList.remove('mt-womo-banner--single');
      setActiveSlide(0, { skipProgressRestart: true });

      if (isDesignMode) {
        revealScrollEnterContent(section);
        return;
      }

      if (autoplayEnabled) restartProgress();
      else stopProgress();
    }

    bindInteractions();
    initSlides();

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        applyTransform(currentIndex);
      }, 150);
    });

    return {
      showBlock: function (blockId) {
        var index = findSlideIndexByBlockId(section, blockId);
        if (index >= 0) setActiveSlide(index, { skipProgressRestart: true });
      },
      destroy: function () {
        clearAutoplay();
        stopProgress();
        clearTimeout(resizeTimer);
      }
    };
  }

  var controllers = new WeakMap();

  function setupBanner(section) {
    if (controllers.has(section)) {
      controllers.get(section).destroy();
    }
    section.classList.add('mt-womo-banner--initialized');
    var controller = createBannerController(section);
    if (controller) controllers.set(section, controller);
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('.mt-womo-banner[data-section-id]').forEach(setupBanner);
  }

  function findBannerSectionFromEventTarget(target) {
    if (!target) return null;
    if (target.classList && target.classList.contains('mt-womo-banner')) return target;
    return target.querySelector ? target.querySelector('.mt-womo-banner[data-section-id]') : null;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  if (isDesignMode) {
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var section = findBannerSectionFromEventTarget(event.target);
      if (!section || !event.detail || !event.detail.blockId) return;
      var controller = controllers.get(section);
      if (controller) controller.showBlock(event.detail.blockId);
    });
  }
})();
